import { Reveal } from "./Reveal";
import { WaitlistForm } from "./WaitlistForm";

export const FinalCta = () => (
  <section id="waitlist" className="noise-overlay relative overflow-hidden bg-[#3B5FE8] py-24 lg:py-32">
    <div className="hero-grid-bg absolute inset-0 opacity-40" aria-hidden="true" />
    <div className="relative z-10 mx-auto max-w-4xl px-6 text-left lg:px-10">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-white/70">Early access</p>
        <h2 className="font-heading mt-4 max-w-2xl text-4xl font-medium tracking-tighter text-white sm:text-5xl lg:text-6xl">
          The future of money won't wait. Neither should you.
        </h2>
        <p className="mt-6 max-w-xl text-base text-white/80 lg:text-lg">
          Join the waitlist for priority onboarding — merchants, platforms and partners get first access to checkout, payouts, the Nomoex Card and P2P.
        </p>
        <div className="mt-10">
          <WaitlistForm source="footer" light />
        </div>
      </Reveal>
    </div>
  </section>
);
